import { render, staticRenderFns } from "./InhaledCorticosteroidDialog.vue?vue&type=template&id=430bd254&"
import script from "./InhaledCorticosteroidDialog.vue?vue&type=script&lang=js&"
export * from "./InhaledCorticosteroidDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports